var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailTemplate = function SvgEmailTemplate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M9.363 2c.908 0 1.63 0 2.214.048.597.048 1.106.15 1.572.388a4 4 0 0 1 1.586 1.46.314.314 0 0 1-.106.429l-4.124 2.624c-1.08.687-1.486.935-1.906 1.032a2.667 2.667 0 0 1-1.198 0c-.42-.097-.827-.345-1.906-1.032L1.372 4.325a.314.314 0 0 1-.107-.429 4 4 0 0 1 1.586-1.46c.466-.238.975-.34 1.572-.388C5.006 2 5.73 2 6.637 2h2.726Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M14.893 5.737c.17-.108.393-.001.405.2.035.549.035 1.198.035 1.978v.114c0 .909 0 1.632-.047 2.215-.05.597-.151 1.106-.389 1.572a4 4 0 0 1-1.748 1.748c-.466.238-.975.34-1.572.388-.583.048-1.306.048-2.214.048H2.667a.667.667 0 0 1 0-1.333H6a.667.667 0 0 0 0-1.334H1.333a.667.667 0 1 1 0-1.333h2a.667.667 0 0 0 0-1.333H.667a.667.667 0 0 1 0-1.334c.001-.528.009-.99.035-1.396a.261.261 0 0 1 .405-.2L4.885 8.14c.935.596 1.545.984 2.216 1.139a4 4 0 0 0 1.798 0c.67-.155 1.281-.543 2.216-1.139l3.778-2.404Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailTemplate);
export default ForwardRef;